const cityPicker = {
    state: {
        countryList: [],
    },
    mutations: {
      GET_COUNTRY_LIST: (state, arr) => {
          console.log(arr, 'store')
        state.countryList = arr;
      }
    },
    actions: {
    }
  }
  
  export default cityPicker
  


// WEBPACK FOOTER //
// ./src/store/modules/cityPicker.js